import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import {PrimeReactProvider} from "primereact/api";
import AuthProvider from "./providers/auth/auth-provider";
import MessageProvider from "./providers/message/message-provider";
import TransportProvider from "./transport/transport-provider";
import PagesProvider from "./models/pages/pages-provider";
import RecordsProvider from './models/records/records-provider';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  }
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PrimeReactProvider>
        <MessageProvider>
          <AuthProvider>
            <TransportProvider>
              <PagesProvider>
                <RecordsProvider>
                  <App />
                </RecordsProvider>
              </PagesProvider>
            </TransportProvider>
          </AuthProvider>
        </MessageProvider>
      </PrimeReactProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
